<template>
  <v-app>
    <v-system-bar v-if="!!localSeleccionado" app color="orange" :height="$vuetify.breakpoint.xsOnly ? '64' : '32'">
      <strong>
        <v-btn text color="secondary">
          {{ localSeleccionado.fase.fspDescripcion }}
        </v-btn>
        {{ localSeleccionado.lapCodigo }} | {{ localSeleccionado.local.nombre }} :::: {{ localSeleccionado.sede.sedNombre }}
      </strong>
    </v-system-bar>
    <v-navigation-drawer v-model="drawer" fixed clipped app width="300">
      <v-list dense>
        <v-list-item v-if="localesAsignados.length > 1 || $store.getters.tieneRol([1])" @click="seleccionDialog = true">
          <v-list-item-action class="mr-2">
            <v-icon>$alt_route</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Selección de Fase y Local
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <template v-for="(item, i) in items">
          <v-list-group v-if="item.children" :key="i" no-action>
            <v-list-item slot="activator" class="px-0">
              <v-list-item-action class="mr-2">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-for="(child, j) in item.children"
              :key="i + '-' + j"
              :to="child.to"
              :href="child.href"
              :target="child.href && '_blank' || undefined"
            >
              <v-list-item-action v-if="child.icon" class="mr-2">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-badge v-if="child.count > 0" color="red">
                <span slot="badge">{{ child.count }}</span>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-badge>
              <v-list-item-content v-else>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item v-else :key="i" :to="item.to">
            <v-list-item-action class="mr-2">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template #append>
        <div class="text-center mb-5" style="font-size: 12px;">
          v{{ appVersion }}
        </div>
      </template>
    </v-navigation-drawer>
    <d-header
      v-model="drawer"
      :title="title"
      :username="rol"
      :logged="true"
      :profile="profile"
      :show-side-icon="true"
    />

    <v-main>
      <v-container id="contenedor" fluid>
        <router-view v-if="localSeleccionado" />
      </v-container>
      <d-refresher />
      <d-notifier />
      <v-dialog
        v-model="seleccionDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        persistent
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark :disabled="!localSeleccionado" @click="seleccionDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Seleccionar Fase y Local</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text class="px-0">
            <v-container>
              <v-row>
                <v-col>
                  <v-card class="mt-6">
                    <v-card-text>
                      <v-tabs
                        v-model="tabFases"
                        background-color="secondary"
                        :vertical="$vuetify.breakpoint.xsOnly"
                        dark
                        grow
                        @change="cambiaFase"
                      >
                        <v-tabs-slider color="#ff8300" />
                        <v-tab v-for="fase in tabFasesItems" :key="fase.fspCodigo">
                          <v-badge
                            :color="fase.vigente ? 'green': 'red'"
                            :content="fase.vigente ? 'vigente': 'cerrada'"
                          >
                            <v-chip
                              v-if="fase.rdnInvierno == 'S'"
                              color="primary"
                              x-small
                            >
                              INVIERNO
                            </v-chip>
                            {{ fase.fspDescripcion }}
                          </v-badge>
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="tabFases">
                        <v-tab-item
                          v-for="fase in tabFasesItems"
                          :key="fase.fspCodigo"
                        >
                          <v-card v-if="locales.length" flat>
                            <v-card-title>
                              Fase {{ fase.fspDescripcion }}
                            </v-card-title>
                            <v-card-text>
                              <v-data-table
                                :headers="headers"
                                :items="locales"
                                class="elevation-0"
                                hide-default-footer
                                disable-pagination
                              >
                                <template #item.nombre="{ item }">
                                  <strong>{{ nombreLocal(item) }}</strong><br>
                                  <div style="font-size: 12px">
                                    <v-icon small color="blue darken-2">
                                      home
                                    </v-icon>
                                    {{ item.local.direccion || 'Sin dirección registrada' }}
                                    <v-icon small color="blue darken-2">
                                      phone
                                    </v-icon>
                                    {{ fonoLocal(item) || 'Sin teléfonos registrados' }}
                                  </div>
                                </template>
                                <template #item.caja="{ item }">
                                  <v-btn
                                    class="mx-2"
                                    fab
                                    small
                                    color="secondary"
                                    @click="showInfoCaja(item)"
                                  >
                                    <v-icon dark>
                                      $box_outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <template #item.carabinero="{ item }">
                                  <v-btn
                                    class="mx-2"
                                    fab
                                    small
                                    color="green"
                                    @click="showInfoCarabinero(item)"
                                  >
                                    <v-icon color="white">
                                      $account_pilot
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <template #item.ingresar="{ item }">
                                  <v-btn
                                    class="mx-2"
                                    fab
                                    small
                                    :disabled="!fase.vigente"
                                    color="secondary"
                                    @click="seleccionarLocal(item)"
                                  >
                                    <v-icon dark>
                                      arrow_forward
                                    </v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>
                    <v-card-actions v-if="esDelegado" class="d-flex justify-center">
                      <v-btn color="secondary" class="mb-4" :loading="loadingNombreSocial" @click="dowloadNombreSocial()">
                        <v-icon>$file_account</v-icon>nombre social
                      </v-btn>
                      <v-btn color="secondary" class="mb-4" @click="showInfoCajasDelegado">
                        <v-icon dark>
                          $box_outline
                        </v-icon> cajas
                      </v-btn>
                      <v-btn color="secondary" class="mb-4" :loading="loadComisaria" @click="comisariaDialog = loadComisaria = true">
                        <v-icon dark>
                          $police_station
                        </v-icon> comisaría
                      </v-btn>
                      <v-btn color="secondary" class="mb-4" @click="showinformeDelegado">
                        informe delegado
                      </v-btn>
                      <v-btn color="secondary" class="mb-4" :loading="loadingDelegado" @click="downloadDelegado()">
                        <v-icon dark>
                          $download
                        </v-icon>pesd
                      </v-btn>
                      <v-btn color="secondary" class="mb-4" @click="$router.push({ name: 'logout' });">
                        <v-icon dark>
                          exit_to_app
                        </v-icon> Salir
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
    <d-dialog-info-caja v-if="infoCajaDialog" v-model="infoCajaDialog" :local="local" />
    <d-dialog-comisaria v-if="comisariaDialog" v-model="comisariaDialog" :sede="sede" :fase="faseSeleccionada" @input="loadComisaria = $event" />
    <d-dialog-carabinero v-if="carabineroDialog" v-model="carabineroDialog" :local="local" />
    <d-dialog-informe-delegado v-if="informeDelegadoDialog" v-model="informeDelegadoDialog" :sede="sede" :fase="faseSeleccionada" />
    <d-dialog-info-caja-delegado v-if="infoCajaDelegadoDialog" v-model="infoCajaDelegadoDialog" :fase="faseSeleccionada" />
    <d-footer />
  </v-app>
</template>

<script>
import Header from '@demre/client-common/src/components/header';
import Refresher from '@demre/client-common/src/components/jwt-refresher';
import Footer from '@demre/client-common/src/components/footer';
import Notifier from '@demre/client-common/src/components/notifier';
import DialogInfoCaja from './pages/info/DialogInfoCaja';
import DialogComisaria from './pages/info/DialogComisaria';
import DialogCarabinero from './pages/info/DialogCarabinero';
import InformeDelegado from './pages/info/InformeDelegado';
import DialogInfoCajaDelegado from './pages/info/DialogInfoCajaDelegado';
import graphql from '../src/utils/graphql';
import { saveAs } from 'file-saver';

export default {
  components: {
    'd-header': Header,
    'd-refresher': Refresher,
    'd-footer': Footer,
    'd-notifier': Notifier,
    'd-dialog-info-caja': DialogInfoCaja,
    'd-dialog-comisaria': DialogComisaria,
    'd-dialog-carabinero': DialogCarabinero,
    'd-dialog-informe-delegado': InformeDelegado,
    'd-dialog-info-caja-delegado': DialogInfoCajaDelegado,
  },
  data: function() {
    return {
      title: 'Portal de Aplicación',
      drawer: true,
      profile: [
        { title: 'Salir', icon: 'power_settings_new', href: { name: 'logout' } }
      ],
      seleccionDialog: false,
      tabFases: null,
      tabFasesItems: [],
      localesAsignadosGroupByFases : {},
      locales: [],
      infoCajaDialog: false,
      informeDelegadoDialog: false,
      local: null,
      faseSeleccionada: null,
      loadPdfCajas: false,
      comisariaDialog: false,
      loadComisaria: false,
      carabineroDialog: false,
      infoCajaDelegadoDialog: false,
      loadingDelegado: false,
      loadingNombreSocial: false
    };
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
    rol() {
      return this.localSeleccionado ? this.localSeleccionado.rol.nombre : '';
    },
    headers() {
      return [
        { text: 'Nro', value: 'local.nroLocal', sortable: false, align: 'center' },
        { text: 'Rbd', value: 'local.local.rbd', sortable: false, align: 'center' },
        { text: 'Local', value: 'nombre', sortable: false, align: 'left' },
        { text: 'Sede', value: 'sede.sedNombre', sortable: false, align: 'left' },
        { text: 'Caja', value: 'caja', sortable: false, align: 'center' },
        { text: 'Carabinero', value: 'carabinero', sortable: false, align: 'center' },
        { text: 'Ingresar', value: 'ingresar', sortable: false, align: 'center' },
      ];

    },
    localesAsignados() {
      return window.DATA.locales;
    },
    esDelegado() {
      if (this.localesAsignados && this.localesAsignados.length) {
        const user = this.localesAsignados[0].usuario;
        return user.includes('DEL');
      }
      return false;
    },
    items() {
      return [
        { icon: 'info', text: 'Información', to: {name: 'home'} },
        { icon: '$file_edit', text: 'Aplicación de Pruebas',
          children: [
            { icon: '$leaderboard', text: 'Resumen Acta Virtual', to: { name: 'resumenActaVirtual'} },
            { icon: '$ballot', text: 'Acta Virtual de Salas', to: { name: 'actaVirtualSalas'} },
            { icon: 'archive', text: 'Archivos de aplicación', to: { name: 'archivosAplicacion' } },
            ...(this.$store.getters.tieneRol([2]) ?[{ icon: '$file_account', text: 'Informe Jefe de Local', to: { name: 'informeJefeLocal' } }] : []),
            { icon: '$monitor', text: 'Monitoreo aplicación', href: 'https://mapp.demre.cl/' },
          ]
        },
        ...(this.$store.getters.tieneRol([1, 2, 4]) ? [{ icon: 'search', text: 'Consulta de inscritos', to: { name: 'postulante'} }] : []),
        {icon: 'group', text: 'Personal de Aplicación',
          children: [
            { icon: '$account_edit', text: 'Información General', to: { name: 'personal'} },
            { icon: '$account_switch', text: 'Reemplazos', to: { name: 'reemplazo'} },
            { icon: '$account_check', text: 'Asistencia', to: { name: 'asistencia'} },
            ...(this.$store.getters.tieneRol([1, 2]) ? [{ icon: '$human', text: 'Contrataciones Inclusión', to: { name: 'contratacionInclusion'} }] : []),
            ...(this.$store.getters.tieneRol([1, 2, 4]) ? [{ icon: '$account_alert', text: 'Problemas de contratación', to: { name: 'problemasContratacion'} }] : [])
          ]
        },
        {icon: '$fact_check', text: 'Evaluación de desempeño', to: { name: 'evaluacion'} },
        {icon: '$human', text: 'Discapacidad y/o ajustes', to: { name: 'psd'} },
      ]
    },
    localSeleccionado() {
      return this.$store.state.local;
    },
    sede() {
      //obtener el codigo de la sede desde los locales y nos aseguramos de sacar la sede ccp
      const locales = this.localesAsignados.filter(l => l.sedCodigo < 500);
      return locales[0].sedCodigo;
    },
    nombreSede() {
      const locales = this.localesAsignados.filter(l => l.sedCodigo < 500);
      return locales[0].sede.sedNombre;
    }
  },
  mounted() {
    if (this.localesAsignados.length == 1 && !this.esDelegado) {
      const [ local ] = this.localesAsignados;
      this.$store.dispatch('loadLocal', { local });
      this.$router.push({name :'home'});
      return;
    }
    this.seleccionDialog = true;
    this.localesAsignadosGroupByFases = this.localesAsignados.reduce((r, a) => {
      r[a.fspCodigo] = [...r[a.fspCodigo] || [], a];
      return r;
    }, {});
    Object.keys(this.localesAsignadosGroupByFases).forEach(f => {
      const fase = window.DATA.fases.find(x => x.fspCodigo == f);
      if (fase) {
        this.tabFasesItems.push(fase);
      }
    });
    this.tabFasesItems.sort((a, b) => a.orden - b.orden);
  },
  methods: {
    home: function() {
      window.location = '/';
    },
    cambiaFase(tab) {
      const {fspCodigo} = this.tabFasesItems[tab];
      this.faseSeleccionada = fspCodigo;
      this.locales = this.localesAsignadosGroupByFases[fspCodigo];
    },
    seleccionarLocal(local) {
      this.$store.dispatch('loadLocal', { local });
      this.seleccionDialog = false;
      if (this.$route.name != 'home') {
        this.$router.push({name :'home'});
      }
    },
    nombreLocal(item) {
      return `${item.lapCodigo} ${item.local.nombre}`;
    },
    fonoLocal(item) {
      const {fono, fonoDos, fonoTres} = item.local;
      return `${[fono, fonoDos, fonoTres].filter(x => x).join(' | ')}`;
    },
    showInfoCaja(item) {
      this.local = item;
      this.infoCajaDialog = true;
    },
    showInfoCarabinero(item) {
      this.local = item;
      this.carabineroDialog = true;
    },
    showInfoCajasDelegado() {
      this.infoCajaDelegadoDialog = true;
    },
    async pdfInfoCajas() {
      this.loadPdfCajas = true;
      try {
        await this.$store.dispatch('session/ensureSession');
        const token = window.localStorage.getItem('token');
        const url = `${process.env.VUE_APP_SERVER_HOST}/api/archivos/info-cajas?token=${token}&fspCodigo=${this.faseSeleccionada}`;
        window.location = url;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.loadPdfCajas = false;
    },
    showinformeDelegado () {
      this.informeDelegadoDialog = true;
    },
    async downloadDelegado() {
      this.loadingDelegado = true;
      const fase = this.tabFasesItems[this.tabFases];
      const variables = {
        sedCodigo: this.sede,
        fspCodigo: fase.fspCodigo,
      }
      try {
        const query = {
          query: `query ($sedCodigo: Int!, $fspCodigo: Int!) {
              url: psdUrlArchDelegado (sedCodigo: $sedCodigo, fspCodigo: $fspCodigo)
            }`,
          variables
        }

        const { url } = await graphql.request(query);
        saveAs(url, `${fase.fspDescripcion}-${ this.nombreSede}_pesd.pdf`);
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.loadingDelegado = false;
    },
    async dowloadNombreSocial() {
      this.loadingNombreSocial = true;
      const fase = this.tabFasesItems[this.tabFases];

      try {
        await this.$store.dispatch('session/ensureSession');
        const token = window.localStorage.getItem('token');
        const url = `${process.env.VUE_APP_SERVER_HOST}/api/archivos/info-nombre-social?token=${token}&sedCodigo=${this.sede}&fspCodigo=${fase.fspCodigo}`;

        const result = await fetch(url, { method: 'GET' });
        if (result.status != 200) {
          this.$store.commit('error-notification', 'En su sede NO hay personas que rindan con Nombre Social');
        } else {
          const blob = await result.blob();
          saveAs(blob, `Listado Nombre Social ${fase.fspDescripcion}-${this.nombreSede}_pesd.pdf`);
        }


      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.loadingNombreSocial = false;
    }
  }
};
</script>

<style>
  .my-upper input {
    text-transform: uppercase
  }
</style>
